import { Preferences } from "@capacitor/preferences";
import { AsyncStorage } from "@tanstack/react-query-persist-client";

export const capacitorPreferencesStorage: AsyncStorage = {
  getItem: async (key) => {
    const { value } = await Preferences.get({ key });
    return value;
  },
  setItem: async (key, value) => {
    await Preferences.set({ key, value });
  },
  removeItem: async (key) => {
    await Preferences.remove({ key });
  },
};
